import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import qs from 'query-string';
import store from '@/vue/store';
import { mapActions, mapMutations } from 'vuex';
import SelectShop from './select-shop.vue';
import SelectCalender from './select-calendar.vue';
import NewsList from './news-list.vue';
import Pager from './pager.vue';
export default {
  store: store,
  components: {
    SelectShop: SelectShop,
    SelectCalender: SelectCalender,
    NewsList: NewsList,
    Pager: Pager
  },
  beforeMount: function beforeMount() {
    var query = qs.parse(location.search); // console.log(query)

    if (query.page) {
      this.setPage(query.page);
    }

    if (query.shop) {
      this.setShop(query.shop);
    }
  },
  mounted: function mounted() {
    this.getNewList();
  },
  methods: _objectSpread({}, mapActions('news-store', ['getNewList']), {}, mapMutations('news-store', ['setPage', 'setShop']))
};